export default "__VITE_ASSET__DaPmwTye__"